import { Divider } from "@msuite/ui/divider";
import { Select, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { getRegionTranslationKey, REGIONS } from "@msuite/utils/misc";
import type { WorkspaceSchema } from "@msuite/utils/schemas";
import { useFormContext, useWatch } from "react-hook-form";
import { AddressForm } from "../address-form";

export function WorkspaceFormDetails() {
	/** Context */
	const methods = useFormContext<WorkspaceSchema>();
	const name = useWatch({ control: methods.control, name: "name" });

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-6">
			<TextInput
				control={methods.control}
				name="companyName"
				label={t("organization.company")}
				placeholder={name || t("placeholders.company_name")}
				isRequired={false}
				data-cy="workspace-company-name-input"
			/>
			<Divider />
			<AddressForm />
			<Select
				control={methods.control}
				name="region"
				label={t("organization.federal_state")}
				helperText={t("organization.federal_state_hint")}
				isRequired={false}
				isNullable
				options={REGIONS.map((region) => ({
					label: t(getRegionTranslationKey(region)),
					value: region,
					item: { region },
				}))}
				data-cy="workspace-region-select"
			/>
			<Divider />
			<TextInput
				control={methods.control}
				name="phone"
				label={t("personnel.fields.phone")}
				placeholder={t("placeholders.phone")}
				isRequired={false}
				data-cy="workspace-phone-input"
			/>
			<TextInput
				control={methods.control}
				name="email"
				label={t("personnel.fields.email")}
				placeholder={t("placeholders.email")}
				isRequired={false}
				data-cy="workspace-email-input"
			/>
			<TextInput
				control={methods.control}
				name="web"
				label={t("personnel.fields.web")}
				placeholder={t("placeholders.web")}
				isRequired={false}
				data-cy="workspace-web-input"
			/>
		</div>
	);
}
